import { Button, Popover } from "antd";
import { pick } from "lodash";
import React, { useState } from "react";
// import { blue8, orange8 } from "../../Assets/Images";
import Functions from "./Functions";
import Config from "./Config";
import Constant from "./Constants";
import { havePermission } from "../../permissions";
import MARKER_PERMISSIONS from "../../permissions/Markers.json";
const { TENANT_PINS_COLOR, CENSUS_PINS_COLOR, ALL_TENANT_PINS_COLOR, variables } = Constant;
const { getTenantName, getBooleanVale, FormateNumber, getCensusNameMapping } = Functions;
const { allClientMarkersVisibility, extraClientMarkerButtons } = Config;

function MapButtons({
	dispatch,
	tenant,
	selectedData,
	selectedType,

	clientMarkersOnMap,
	selecteddropDown,
	currentSelectedTypeIndex,
	shopsStructure,
	shopCounts,
	markersOnMap,
	all_raw_tenant_markers,
	tenant_markers_1
}) {
	let [popOverOpsn, setPopOverOpen] = useState(false);
	let [clientPopOverOpsn, setClientPopOverOpen] = useState(false);
	let [clientPopOverOpsn_1, setClientPopOverOpen_1] = useState(false);
	let [allClientPopOverOpsn, setAllClientPopOverOpen] = useState(false);

	const CensusSelected = getBooleanVale(selectedData, `Markers.${selectedType}`, false);
	const ClientSelected = getBooleanVale(selectedData, `ClientMarkers.${selectedType}`, false);
	const Client_1_Selected = getBooleanVale(selectedData, `ClientMarkers1.${selectedType}`, false);
	const ALLClientSelected = getBooleanVale(selectedData, `AllClientMarkers.${selectedType}`, false);
	const AssignSelected = getBooleanVale(selectedData, `AssignedMarkers.${selectedType}`, false);
	const UnAssignSelected = getBooleanVale(selectedData, `UnassignedMarkers.${selectedType}`, false);
	const selectedIds = selecteddropDown[currentSelectedTypeIndex] || [];
	let totalShops = 0;
	let totalShopsAvailable = 0;

	let totalClientShops = 0;
	let totalClientShopsAvailable = 0;

	let totalClientShops_1 = 0;
	let totalClientShopsAvailable_1 = 0;

	if (selectedIds.length > 0) {
		totalShops = Object.values(pick(shopCounts, selectedIds)).reduce((a, b) => a + b, 0);
		for (let id of selectedIds) {
			if (shopsStructure.has(id)) {
				totalShopsAvailable += shopsStructure.get(id)?.length;
			}
		}

		const forClient = selectedIds.map(key => `${key}-Client`);
		totalClientShops = Object.values(pick(shopCounts, forClient)).reduce((a, b) => a + b, 0);
		for (let id of forClient) {
			if (shopsStructure.has(id)) {
				totalClientShopsAvailable += shopsStructure.get(id)?.length;
			}
		}

		const forClient_1 = selectedIds.map(key => `${key}-${variables.bat_contracted_outlets}`);
		totalClientShops_1 = Object.values(pick(shopCounts, forClient_1)).reduce((a, b) => a + b, 0);
		for (let id of forClient_1) {
			if (shopsStructure.has(id)) {
				totalClientShopsAvailable_1 += shopsStructure.get(id)?.length;
			}
		}
	}
	return (
		<div className="d-flex ">
			{" "}
			{havePermission(MARKER_PERMISSIONS.MARKER_CENSUS_VIEW) && (
				<Popover
					content={
						<div>
							<table>
								<tr>
									<th className="elipsis-count">Total Shops</th>
									<th className="elipsis-count">Downloaded Shops</th>
									<th className="elipsis-count">Shops For Map</th>
								</tr>
								<tr>
									<td className="elipsis-count">{FormateNumber(totalShops)}</td>
									<td className="elipsis-count">{FormateNumber(totalShopsAvailable)}</td>
									<td className="elipsis-count">{FormateNumber(markersOnMap)}</td>
								</tr>
							</table>
						</div>
					}
					title="Shops Info"
					trigger="click"
					open={popOverOpsn}
					onOpenChange={value => {
						setPopOverOpen(value);
					}}
				>
					<Button
						onMouseEnter={() => setPopOverOpen(true)}
						onMouseLeave={() => setPopOverOpen(false)}
						// disabled={selectedIds}
						// loading={CensusLoading}
						style={{
							backgroundColor: CensusSelected ? "#ffd666" : "",
							color: CensusSelected ? "black" : ""
						}}
						onClick={() => {
							dispatch({
								type: "setObject",
								actions: {
									set: {
										[`selectedData.Markers.${selectedType}`]: !CensusSelected
									}
								}
							});
						}}
						className="mr-2 d-flex align-items-center"
						// icon={
						// 	<img
						// 		class="manImg mr-1"
						// 		style={{
						// 			width: "15px",
						// 			height: "15px"
						// 		}}
						// 		alt="No Source"
						// 		src={blue8}
						// 	/>
						// }
					>
						<span
							className="manImg mr-1"
							style={{
								width: "15px",
								height: "15px",
								backgroundColor: CENSUS_PINS_COLOR(tenant),
								display: "inline-block"
							}}
						/>
						{getCensusNameMapping(tenant)}
					</Button>
				</Popover>
			)}
			{havePermission(MARKER_PERMISSIONS.TABLE_CLINET_1_SHOPS_COUNT) && (
				<Popover
					content={
						<div>
							<table>
								<tr>
									<th className="elipsis-count">Total Shops</th>
									<th className="elipsis-count">Downloaded Shops</th>
									<th className="elipsis-count">Shops For Map</th>
								</tr>
								<tr>
									<td className="elipsis-count">{totalClientShops_1}</td>
									<td className="elipsis-count">{totalClientShopsAvailable_1}</td>
									<td className="elipsis-count">{tenant_markers_1}</td>
								</tr>
							</table>
						</div>
					}
					title={`${getTenantName(tenant)} Info`}
					trigger="click"
					open={clientPopOverOpsn_1}
					onOpenChange={value => {
						setClientPopOverOpen_1(value);
					}}
				>
					<Button
						onMouseEnter={() => setClientPopOverOpen_1(true)}
						onMouseLeave={() => setClientPopOverOpen_1(false)}
						// disabled={selectedIds}
						// loading={CensusLoading}
						style={{
							backgroundColor: Client_1_Selected ? "#95de64" : "",
							color: Client_1_Selected ? "black" : ""
						}}
						onClick={() => {
							dispatch({
								type: "setObject",
								actions: {
									set: {
										[`selectedData.ClientMarkers1.${selectedType}`]: !Client_1_Selected
									}
								}
							});
						}}
						className="mr-2 d-flex align-items-center"
					>
						<span
							className="manImg mr-1"
							style={{
								width: "15px",
								height: "15px",
								backgroundColor: TENANT_PINS_COLOR(tenant) || "yellow",
								display: "inline-block"
							}}
						/>
						{variables.bat_contracted_outlets}
					</Button>
				</Popover>
			)}
			{allClientMarkersVisibility[tenant] && (
				<Popover
					content={
						<div>
							<table>
								<tr>
									<th className="elipsis-count">Total Shops</th>
									<th className="elipsis-count">Downloaded Shops</th>
									<th className="elipsis-count">Shops For Map</th>
								</tr>
								<tr>
									<td className="elipsis-count">{all_raw_tenant_markers}</td>
									<td className="elipsis-count">{all_raw_tenant_markers}</td>
									<td className="elipsis-count">{all_raw_tenant_markers}</td>
								</tr>
							</table>
						</div>
					}
					title={`${getTenantName(tenant)} Info`}
					trigger="click"
					open={allClientPopOverOpsn}
					onOpenChange={value => {
						setAllClientPopOverOpen(value);
					}}
				>
					<Button
						onMouseEnter={() => setAllClientPopOverOpen(true)}
						onMouseLeave={() => setAllClientPopOverOpen(false)}
						// disabled={selectedIds}
						// loading={CensusLoading}
						style={{
							backgroundColor: ALLClientSelected ? "#95de64" : "",
							color: ALLClientSelected ? "black" : ""
						}}
						onClick={() => {
							dispatch({
								type: "setObject",
								actions: {
									set: {
										[`selectedData.AllClientMarkers.${selectedType}`]: !ALLClientSelected
									}
								}
							});
						}}
						className="mr-2 d-flex align-items-center"
					>
						<span
							className="manImg mr-1"
							style={{
								width: "15px",
								height: "15px",
								backgroundColor: ALL_TENANT_PINS_COLOR(tenant),
								display: "inline-block"
							}}
						/>
						{getTenantName(tenant)} (ALL)
					</Button>
				</Popover>
			)}
			{extraClientMarkerButtons[tenant] &&
				extraClientMarkerButtons[tenant].map((button, index) => {
					const { buttonText, type = "client" } = button;
					const isButtonSelected = getBooleanVale(selectedData, `${buttonText}.${selectedType}`, false);
					const otherButtonTexts = extraClientMarkerButtons[tenant]
						.filter(btn => btn.buttonText !== buttonText)
						.map(btn => btn.buttonText);

					return (
						<Button
							disabled={button?.disabled}
							key={index}
							style={{
								color: button.disabled ? "black" : "black",
								...(!button.disabled && {
									backgroundColor: isButtonSelected ? button?.color || "#95DE64" : "",
									color: isButtonSelected ? "black" : ""
								})
							}}
							onClick={() => {
								dispatch({
									type: "setObject",
									actions: {
										set: {
											[`selectedData.${button.text}Markers.${selectedType}`]:
												button.text === "Assigned" ? !AssignSelected : !UnAssignSelected,

											[`selectedData.${
												button.text === "Assigned" ? "Unassigned" : "Assigned"
											}Markers.${selectedType}`]: false
										}
									}
								});
								dispatch({
									type: type === "client" ? "FilterClientShops" : "FilterCensusShops",
									value: {
										key: button.mappedKey,
										value: !ClientSelected,
										text: button.filterValue,
										tenant,
										color: button.color ? button.color : ""
									}
								});
								button.autoLoadShops &&
									dispatch({
										type: "setObject",
										actions: {
											set: {
												[`selectedData.Markers.${selectedType}`]: !isButtonSelected,
												[`selectedData.${buttonText}.${selectedType}`]: !isButtonSelected
											}
										}
									});
								otherButtonTexts.forEach(text => {
									dispatch({
										type: "setObject",
										actions: {
											set: {
												[`selectedData.${text}.${selectedType}`]: false
											}
										}
									});
								});

								// dispatch({
								// 	type: "UPDATETABLEDATA"
								// });
							}}
							className={
								type === "client"
									? "mr-2 d-flex align-items-center ml-auto mr-10"
									: "mr-2 d-flex align-items-center"
							}
						>
							{button.color && (
								<span
									className="manImg mr-1"
									style={{
										width: "15px",
										height: "15px",
										backgroundColor: button.color ? button.color : "",
										display: "inline-block"
									}}
								/>
							)}
							{button.disabled && (
								<span
									className="manImg mr-1"
									style={{
										width: "15px",
										height: "15px",
										backgroundColor: buttonText === "Temporarily Closed" ? "#800080" : "#116D6E",
										display: "inline-block"
									}}
								/>
							)}

							{buttonText}
						</Button>
					);
				})}
			{havePermission(MARKER_PERMISSIONS.MARKER_CLIENT_VIEW) && (
				<Popover
					content={
						<div>
							<table>
								<tr>
									<th className="elipsis-count">Total Shops</th>
									<th className="elipsis-count">Downloaded Shops</th>
									<th className="elipsis-count">Shops For Map</th>
								</tr>
								<tr>
									<td className="elipsis-count">{totalClientShops}</td>
									<td className="elipsis-count">{totalClientShopsAvailable}</td>
									<td className="elipsis-count">{clientMarkersOnMap}</td>
								</tr>
							</table>
						</div>
					}
					title={`${getTenantName(tenant)} Info`}
					trigger="click"
					open={clientPopOverOpsn}
					onOpenChange={value => {
						setClientPopOverOpen(value);
					}}
				>
					<Button
						onMouseEnter={() => setClientPopOverOpen(true)}
						onMouseLeave={() => setClientPopOverOpen(false)}
						// disabled={selectedIds}
						// loading={CensusLoading}
						style={{
							backgroundColor: ClientSelected ? "#95de64" : "",
							color: ClientSelected ? "black" : ""
						}}
						onClick={() => {
							dispatch({
								type: "setObject",
								actions: {
									set: {
										[`selectedData.ClientMarkers.${selectedType}`]: !ClientSelected
									}
								}
							});
						}}
						className="mr-2 d-flex align-items-center"
					>
						<span
							className="manImg mr-1"
							style={{
								width: "15px",
								height: "15px",
								backgroundColor: TENANT_PINS_COLOR(tenant) || "#FF8C00",
								display: "inline-block"
							}}
						/>
						{getTenantName(tenant)}
					</Button>
				</Popover>
			)}
			{/* {additionalComponents} */}
		</div>
	);
}

export default MapButtons;
